import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromPtCore from '../store/reducers/pt-core.reducer';
import * as PtCoreActions from '../store/actions/pt-core.actions';
import * as PtCoreSelectors from '../store/selectors/pt-core.selectors';
import { PtUiAppRoutes } from '@pt/pt-models';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class NoMicrosoftModuleGuardService {
  constructor(
    private store: Store<fromPtCore.CoreState>,
    private localStorageService: LocalStorageService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    this.localStorageService.setLatestPage(window.location.href);
    return this.store.pipe(
      select(PtCoreSelectors.isSystemOrAdminOrNoAuth),
      map((routesNavigationAllowed) => {
        if (routesNavigationAllowed) {
          return true;
        } else {
          this.store.dispatch(
            PtCoreActions.navigateTo({ route: [PtUiAppRoutes.HOME] })
          );
          return false;
        }
      })
    );
  }
}
